import React from 'react';

const NotFoundPage = React.lazy(() => import('./components/notFound/NotFoundPage'));
const QuickRegistrationShortLink = React.lazy(() => import('./views/QuickRegistrationView/QuickRegShortLink'));
const QuickRegistrationV2View = React.lazy(() => import('./views/QuickRegistrationView/QuickRegistrationV2View'));
const HomeLandingView = React.lazy(() => import('./views/HomeLandingView/HomeLandingView'));

const routes = [
  {
    path: '',
    exact: true,
    component: HomeLandingView,
    documentTitle: 'DocTitle.QuickRegistration',
  },
  {
    path: '/home',
    exact: true,
    component: HomeLandingView,
    documentTitle: 'DocTitle.Home',
  },
  {
    path: '/home/:code',
    exact: true,
    component: HomeLandingView,
    documentTitle: 'DocTitle.Home',
  },
  {
    path: `/join`,
    exact: false,
    component: QuickRegistrationV2View,
    documentTitle: 'DocTitle.QuickRegistration',
  },
  {
    path: `/join/:code`,
    exact: false,
    component: QuickRegistrationV2View,
    documentTitle: 'DocTitle.QuickRegistration',
  },
  {
    path: `/quick-reg`,
    exact: false,
    component: QuickRegistrationV2View,
    documentTitle: 'DocTitle.QuickRegistration',
  },
  {
    path: `/:code`,
    exact: false,
    component: HomeLandingView,
    documentTitle: 'DocTitle.QuickRegistration',
  },
  // {
  //   path: '/not-found',
  //   authorize: ['user'],
  //   component: NotFoundPage,
  //   documentTitle: 'DocTitle.PageNotFound',
  // },
];

export default routes;
